<template>
    <AppCard class="!rounded-2xl border-0 shadow-none md:!shadow-lg md:border overflow-hidden relative">
        <Transition name="fade" @before-enter="transitioning = true" @after-leave="transitioning = false">
            <LoadingOverlay blur v-if="questionsLoading"></LoadingOverlay>
        </Transition>

        <div class="flex mb-4 items-center">
            <div class="flex-none block md:hidden mr-8">
                <div class="relative">
                    <div class="absolute left-0" v-if="product.top_badges.length">
                        <div v-for="( badge, counter) in product.top_badges">
                            <img class="absolute round-full max-w-[65px]" :class="counter === 0 ? 'top-0' : 'top-28'"
                                 :src="badge.path"
                                 :alt="badge.name"
                            />
                        </div>
                    </div>
                </div>
                <img :src="product.image" class="max-w-[139px] max-h-fit">
            </div>
            <div class="flex-grow">
                <OverallUserRating :review-count="product.reviews_count"
                                   :rating="product.reviews_avg_rating"></OverallUserRating>
            </div>
        </div>

        <ProgressBar
            class="mb-3"
            v-for="(question, index) of localQuestions"
            :key="index"
            :transition-delay="index * 50"
            :transition-duration="300 + (index * 50)"
            :label="question.title"
            :progress="!transitioning ? question.reviews_avg_review_questionanswer : 0"
            :max="10"
        ></ProgressBar>

        <div v-auto-animate>
            <div class="text-center" v-if="competitor && !transitioning">
                <InertiaLink :href="route('products.show', competitor)">
                    <AppButton v-if="competitor.best_in_class || competitor.highest_rated_in_class" theme="secondary" class="mx-auto w-full h-9">
                        View the
                        <template v-if="competitor.best_in_class">Best-in-Class tyre instead</template>
                        <template v-else-if="competitor.highest_rated_in_class">Users's Choice tyre instead</template>
                    </AppButton>
                    <AppButton v-else theme="orange" class="mx-auto w-full h-9">
                        View Steve's Preferred Tyre Here
                    </AppButton>
                </InertiaLink>
            </div>
        </div>
    </AppCard>
</template>

<script setup>
import {InertiaLink} from "@inertiajs/inertia-vue3";
import AppCard from "@/Components/AppCard";
import ReviewStarRating from "@/Components/Reviews/ReviewStarRating";
import ProgressBar from "@/Components/ProgressBar/ProgressBar";
import LoadingOverlay from "@/Components/LoadingOverlay";
import OverallUserRating from "@/Components/Products/OverallUserRating";
import AppButton from "@/Components/AppButton";
import {useProductQuestions, useCompetitionProduct} from "@/Composables/products";
import {ref, watch} from "vue";

const props = defineProps({
    product: Object,
    questions: Array
});

const localQuestions = ref(props.questions);

const {questions, loading: questionsLoading} = useProductQuestions(props.product);

watch(questions, (newQuestions) => {
    localQuestions.value = newQuestions;
});

const {
    loading: competitorLoading,
    product: competitor
} = useCompetitionProduct(props.product);


const transitioning = ref(questionsLoading.value);
</script>

<style scoped>

</style>
